// Only in-app paths. Reject protocol-relative and off-site targets so a
// login bounce cannot be turned into an open redirect.
function safeInternalRedirect(value) {
  if (typeof value !== 'string') return '/';
  const path = value.trim();
  if (!path.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) return '/';
  if (path.includes('\\') || path.includes('://') || path.includes('\0')) return '/';
  return path;
}

module.exports = safeInternalRedirect;
